export default __webpack_public_path__ + "static/media/head-bg-1.e7e8270b.svg";